import API from "../api/api";

const config = (token) => {
  return {
    headers: {
      "Content-type": "application/json",

      "X-Frame-Options": "DENY",
      "Content-Security-Policy": "style-src 'self'",
      Authorization: `Bearer ${token}`,
    },
  };
};

export const createSession = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(`get-mediums`, body, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getZoom = async (medium) => {
  let token = localStorage.getItem("access_token");
  const currentTime = getCurrentTime();

  const configHeaders = (token, params) => {
    return {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: params,
    };
  };
  let body = {
    start_time: currentTime,
    duration: 30,
    host_video: "",
    participant_video: "",
    agenda: "",
    topic: "Medium Session",
  };
  if (medium) {
    body.medium = medium;
  }
  const response = await API.get(`get-zoom-link`, configHeaders(token, body))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

const getCurrentTime = () => {
  const time = new Date();
  console.log(time, "timetimetimetime");
  const currentTime =
    time.getFullYear() +
    "-" +
    ("00" + (time.getMonth() + 1)).slice(-2) +
    "-" +
    ("00" + time.getDate()).slice(-2) +
    "T" +
    ("00" + time.getHours()).slice(-2) +
    ":" +
    ("00" + time.getMinutes()).slice(-2) +
    ":" +
    ("00" + time.getSeconds()).slice(-2);
  console.log(currentTime);
  return currentTime;
};

export const getMatchedAvailabilites = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    `get-matched-availabilites`,
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const saveSessionTerms = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(`save-session-terms`, body, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const saveAdvanceBooking = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(`save-advance-booking`, body, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};


export const saveDirectAdvanceBooking = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    `save-direct-advance-appointment`,
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getAllAppointments = async (data, appointmentType) => {
  console.log("paginatedData", data);
  console.log("appointmentType", appointmentType);
  let token = localStorage.getItem("access_token");
  let page = data !== undefined ? data.page : 1;
  let rowsPerPage = data !== undefined ? data.rowsPerPage : 10;
  const response = await API.get(
    `appointment-show?page=${page}&appoitment_type=${appointmentType}&rowsPerPage=${rowsPerPage}`,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const getClientCount = async () => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(`get-client-appointment-status`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getClientPreferences = async () => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(`get-client-preferences`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const setClientPreferences = async (body) => {
  let token = localStorage.getItem("access_token");

  const response = await API.post(`set-client-preferences`, body, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const updateLegalprivacy = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post("update-client-legal-privacy", body, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const getPractitionars = async () => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(
    `get-prodessional-mediums?ondemand=yes`,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const getPractitionarsFilter = async (body, signal) => {
  const {
    allow_REcording,
    languages,
    specialities,
    whereDoIPay,
    sessionLength,
    experience,
    selectedName,
    session_currency,
    availability,
    favorites_only,
  } = body;
  let token = localStorage.getItem("access_token");

  const response = await API.get(
    `get-prodessional-mediums?ondemand=yes&allow_recordings=${allow_REcording}&languages[]=${languages}&specialities[]=${specialities}&pay_type[]=${whereDoIPay}&session_length[]=${sessionLength}&medium_professional_category[]=${experience}&screen_name=${encodeURIComponent(
      (selectedName || "").trim()
    )}&session_currency=${encodeURIComponent(session_currency || "")}&availability=${availability}&favorites_only=${
      favorites_only ? 1 : 0
    }`,
    { ...config(token), signal }
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const toggleFavoriteMedium = async (medium_id) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    `user/toggle-favorite-medium`,
    { medium_id },
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getFavoriteMediums = async () => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(`user/favorite-mediums`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getPractitionarInfo = async (id, coachReviews = null) => {
  let token = localStorage.getItem("access_token");
let url = `user/get-medium-details?medium=${id}`;
    if (coachReviews !== null) {
        url += `&coachReviews=${coachReviews}`;
    }
  const response = await API.get(url,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getMediumFeedbacksList = async (medium_id, offset = 0, limit = 2) => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(
    `user/get-medium-feedbacks?medium=${medium_id}&offset=${offset}&limit=${limit}`,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getMediumCoachFeedbacksList = async (medium_id, offset = 0, limit = 2) => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(
    `user/get-medium-coach-feedbacks?medium=${medium_id}&offset=${offset}&limit=${limit}`,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getProfileBasicInfo = async (id) => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(`profile-info`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getLegalAndServicesForClient = async (id) => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(`get-client-legal-privacy`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const getSlotsByDate = async (
  date,
  user_type,
  session_id,
  medium_id,
  subsession_id = "",
  is_group_session,
  client_id,
  is_medium_booking,
  activemedium_availability_id

) => {
  console.log(session_id ,'sam', activemedium_availability_id);
  let url1 = `group/coaching/get-medium-slots-by-date?date=${date}
  &session_id=${session_id}&medium_id=${medium_id}&subsession_id=${subsession_id}
  &is_medium_list=true&is_medium_booking=${is_medium_booking}&id=${activemedium_availability_id ? activemedium_availability_id : ""}`;
  let url = client_id == "" ? `get-slots-by-date?date=${date}&session_id=${session_id !== "" && session_id !== undefined ? session_id : "5"
    }&medium_id=${medium_id}&subsession_id=${subsession_id}&is_medium_booking=${is_medium_booking}` :
    `get-slots-by-date?date=${date}&session_id=${session_id !== "" && session_id !== undefined ? session_id : "5"
    }&medium_id=${medium_id}&subsession_id=${subsession_id}&client_id=${client_id}&is_medium_booking=${is_medium_booking}`
    ;
  let token = localStorage.getItem("access_token");
  const response = await API.get(is_group_session == 1 ? url1 : url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const changeAppointmentStatus = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "client-change-appointment-status",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getBannerPage = async () => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(`get-banner-page`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
 
export const getSlotsCountByDate = async (body, is_group_session) => {
  console.log(body, "datada");
  let token = localStorage.getItem("access_token");
  let url1 = `group/coaching/get-medium-calendar?from=${body.startDate}
  &id=${body.activemedium_availability_id ? body.activemedium_availability_id : ""}
  &to=${body.endDate}
  &medium_id=${body.medium_id == false ? "" : body.medium_id}
  &service=${body.session_id}
  &session_length=${body.subsession_id}&is_medium_booking=${body.is_medium_booking}`;
  let url =
    body.user_type !== undefined
      ? `get-slots-count-by-from-to-date?from=${body.startDate}&to=${body.endDate
      }&session_id=${body.session_id == "" ? "5" : body.session_id
      }&medium_id=${body.medium_id == false ? "" : body.medium_id
      }&subsession_id=${body.subsession_id}&client_id=${body.client_id}`
      : `get-slots-count-by-from-to-date?from=${body.startDate}&to=${body.endDate
      }&session_id=${body.session_id == "" ? "5" : body.session_id
      }&medium_id=${body.medium_id == false ? "" : body.medium_id
      }&subsession_id=${body.subsession_id}&is_medium_booking=${body.is_medium_booking}`;
  const response = await API.get(is_group_session == 1 ? url1 : url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const payWithPaypal = async (body) => {
  let url = `paypal-access?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}`;
  let token = localStorage.getItem("access_token");
  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const payWithStripe = async (body) => {
  let url = `stripe-access?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}`;
  let token = localStorage.getItem("access_token");
  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const payWithSquareUp = async (body) => {
  let url = `square-up-access?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}`;
  let token = localStorage.getItem("access_token");
  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const payWithPaypalCompleted = async (body) => {
  let url =
    body.payment_source !== undefined
      ? `paypal-access/${body.id}?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}&client_id=${body.client_id}&payment_source=${body.payment_source}`
      : `paypal-access/${body.id}?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}&appointment_type=${body.appointment_type}&client_id=${body.client_id}`;
  let token = localStorage.getItem("access_token");
  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const payWithStripeCompleted = async (body) => {
  let url =
    body.payment_source !== undefined
      ? `stripe-access/${body.id}?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}&client_id=${body.client_id}&payment_source=${body.payment_source}`
      : `stripe-access/${body.id}?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}&appointment_type=${body.appointment_type}&client_id=${body.client_id}`;
  let token = localStorage.getItem("access_token");
  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const payWithSquareCompleted = async (body) => {
  let url =
    body.payment_source !== undefined
      ? `square-up-access/${body.id}?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}&client_id=${body.client_id}&payment_source=${body.payment_source}`
      : `square-up-access/${body.id}?medium_id=${body.medium_id}&amount=${body.amount}&currency=${body.currency}&appointment_type=${body.appointment_type}&client_id=${body.client_id}`;
  let token = localStorage.getItem("access_token");
  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const doAProfessionalPayment = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "save-direct-advance-appointment-return-payment-url",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const doAPayItForwardPayment = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "pay-it-forward",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const giftMediumForAppointment = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "gift-medium",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const doAPayItForwardPaymentProcess = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "pay-it-forward-process",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const getCreateAppointmentSubseesions = async (id) => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(`get-subsessions/${id}`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getMediumServiceDetails = async (id) => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(
    `get-medium-services?medium_id=${id}`,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getDateCount = async (body) => {
  console.log(body, "datada");
  let token = localStorage.getItem("access_token");
  let url = `get-session-data/${body.medium_id}?from=${body.startDate}&to=${body.endDate}&timezone=${body.timezone}&session_id=${body.session_id}&subsession_id=${body.subsession_id}`;

  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getTimeSlotsByDate = async (body) => {
  let token = localStorage.getItem("access_token");
  let url = `get-sesssion-data-by-date/${body.medium_id}?date=${body.date}&timezone=${body.timezone}&session_id=${body.session_id}&subsession_id=${body.subsession_id}`;

  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const createGuestBooking = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "create-guest-booking",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
}
// Guest booking: confirm the password of an email that already has an account.
export const verifyGuestPassword = async (body) => {
  const response = await API.post("guest-booking/verify-password", body)
    .then((data) => data)
    .catch((err) => err);
  return response;
};

/**
 * Public (no-auth) Special Events listing for the guest booking flow
 * (/special-events). Backend endpoint: GET guest/special-events
 *
 * params: { medium_id, availability_id, from, to, search, timezone }
 *   - medium_id / availability_id: optional filters from shared booking links
 *   - from / to: YYYY-MM-DD date range
 *   - timezone: guest's chosen timezone id — times must come back converted
 *
 * Expected response shape:
 * {
 *   status: true,
 *   data: [{
 *     event_id, medium_availability_id, medium_id, medium_name,
 *     languages,            // array of language names
 *     title, description,
 *     date,                 // "YYYY-MM-DD" in guest timezone
 *     start_time, end_time, // "HH:mm" in guest timezone
 *     price, currency, capacity, booked_count,
 *     session_id,           // 35 (Professional Demo)
 *     subsession_id,        // 101
 *     payment_methods       // { is_stripe_integrated, is_paypal_integrated, is_squareup_integrated }
 *                           // per the event's medium — never assume a fixed set of gateways
 *   }]
 * }
 * Full and past events are expected to be excluded server-side; the frontend
 * additionally hides full events (see pages/specialevents/eventFilters.js).
 */
export const getGuestSpecialEvents = async (params) => {
  const response = await API.get("guest/special-events", { params })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getAppointmentInfo = async (id) => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(`appointment/${id}`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const getSessionLimit = async () => {
  let token = localStorage.getItem("access_token");
  const response = await API.get(`get-session-limit`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
}

export const addClientToBackFillQueue = async (event_id, date, end_time, user_pereference) => {
  let token = localStorage.getItem("access_token");

  const response = await API.get(`create-backfill-booking`, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};


export const starterVideoWatched = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "update-client-starter-video-status",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
}

export const saveUserTracks = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "save_user_tracks",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
}
export const saveZoomSession = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "save-zoom-session-request",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
}
export const verifyUserCode = async (code) => {
  
  let token = localStorage.getItem("access_token");
  let url = `verify-user-code?code=${code}`;

  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};

export const interviewScheduleSlots = async (body) => {
  console.log(body, "datada");
  let token = localStorage.getItem("access_token");
  let url = `interview-schedule-slots?from=${body.startDate}&to=${body.endDate}&timezone=${body.timezone}&session_id=${body.session_id}&subsession_id=${body.subsession_id}&client_id=${body.client_id}`;

  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const getInterviewTimeSlotsByDate = async (body) => {
  let token = localStorage.getItem("access_token");
  let medium_id = "";
  let url = `get-interview-slots-by-date?date=${body.date}&session_id=${body.session_id}&subsession_id=${body.subsession_id}&medium_id=${medium_id}&client_id=${body.client_id}`;

  const response = await API.get(url, config(token))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};
export const createInterviewBooking = async (body) => {
  let token = localStorage.getItem("access_token");
  const response = await API.post(
    "create-interview-booking",
    body,
    config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
}
